export default __webpack_public_path__ + "media/images/about_us/living-room-def6613a6c9412bd075f5358bf802d03.webp";